import React, { ReactNode, FC } from "react";

interface LayoutProps {
  children: ReactNode;
}

const OneColLayout: FC<LayoutProps> = ({ children }) => {
  return (
    <main className="oneColumn bg-white pt-20">
      <div className="dashboard-wrapper">{children}</div>
    </main>
  );
};

export default OneColLayout;
